import { TFunction } from 'i18next';
import * as Yup from 'yup';

import { isStreetFreeInputAllowed } from '../../utils/constants/misc';
import {
  conditionallyRequiredField,
  yupMaxField,
  yupRequiredField,
} from '../../utils/helpers/yup';

function settingsDependentRequiredField(
  field: any,
  isRequired: any,
  requiredMessage: any
) {
  return isRequired ? field.required(requiredMessage) : field;
}

// also include fieldSettings:{ municipality: boolean; street: boolean}

export function getAddressSchema(t: TFunction, fieldSettings: any) {
  return Yup.object({
    municipalityId: fieldSettings?.municipality
      ? Yup.number()
          .nullable()
          .required(yupRequiredField(t, t('Municipality')))
      : Yup.number().nullable().optional(),
    municipalityName: Yup.string().nullable().optional(),
    placeId: Yup.number()
      .nullable()
      .required(yupRequiredField(t, t('Place'))),
    placeName: Yup.string().nullable().optional(),
    streetId: conditionallyRequiredField(
      Yup.number().nullable(),
      !isStreetFreeInputAllowed,
      yupRequiredField(t, t('Street'))
    ),
    streetName: Yup.string().nullable().optional(),
    housenumber: settingsDependentRequiredField(
      Yup.string().max(10, ({ max }) => yupMaxField(t, t('Street No.'), max)),
      fieldSettings.RequiredHouseNumber,
      yupRequiredField(t, t('Street No.'))
    ),
    entrance: Yup.string()
      .max(10, ({ max }) => yupMaxField(t, t('Entrance No.'), max))
      .nullable()
      .optional(),
    apartment: Yup.string()
      .max(10, ({ max }) => yupMaxField(t, t('Flat No.'), max))
      .nullable()
      .optional(),

    location: Yup.object({
      lng: Yup.number(),
      lat: Yup.number(),
    })
      .nullable()
      .optional(),

    rawName: conditionallyRequiredField(
      Yup.string().nullable(),
      isStreetFreeInputAllowed,
      yupRequiredField(t, t('Street'))
    ),

    stateId: Yup.number().optional().nullable(),
    countryCode: Yup.string().optional().nullable(),
    countryId: Yup.number().optional().nullable(),
    cityId: Yup.number().optional().nullable(),
    cityName: Yup.string().optional().nullable(),
    postcode: Yup.string().optional().nullable(),
    zoneId: Yup.string().optional().nullable(),
  });
}
